import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';


class PeriodicalReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All Periodical list
            periodicalListLoading: false,
            totalPeriodicalListItems: 0,
            periodicalList: {},
            sortedIdArrayList: [],
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByTitle: '',
            searchByPeriodicalCategory: '',
            searchByPeriodicity: '',
            searchByStatus: 'active',

            periodicalCategoryList: {},
            periodicalCategoryListLoading: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Title", isVisible: true },
                { name: "ISSN Number", isVisible: true },
                { name: "Category", isVisible: true },
                { name: "No. of Copies", isVisible: true },
                { name: "Periodicity", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "No. of Subscription", isVisible: true },
                { name: "Average Price Per Copy", isVisible: true },
                { name: "Publisher", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Title", key: 'title' },
                { name: "ISSN Number", key: 'issnNumber' },
                { name: "Category", key: 'category' },
                { name: "No. of Copies", key: 'noOfCopies' },
                { name: "Periodicity", key: 'periodicity' },
                { name: "Department", key: 'department' },
                { name: "No. of Subscription", key: 'noOfSubscription' },
                { name: "Average Price Per Copy", key: 'averagePricePerCopy' },
                { name: "Publisher", key: 'publisher' }
            ],

            exportItemVisibility: [
                { name: "Title", isVisible: true },
                { name: "ISSN Number", isVisible: true },
                { name: "Category", isVisible: true },
                { name: "No. of Copies", isVisible: true },
                { name: "Periodicity", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "No. of Subscription", isVisible: true },
                { name: "Average Price Per Copy", isVisible: true },
                { name: "Publisher", isVisible: true }
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],
        };
    }

    componentDidMount() {
        this.getPeriodicalList();  // report list
        this.getPeriodicalCategoryList();    // periodical category
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF REPORT
    getPeriodicalList = async () => {
        this.setState({
            periodicalListLoading: true
        });

        let filterData = {
            "title": this.state.searchByTitle,
            "periodicity": this.state.searchByPeriodicity,
            "periodical_category_id": this.state.searchByPeriodicalCategory
        }

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'filterData': filterData,
            'status': this.state.searchByStatus
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPeriodicalList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {

                        this.setState({
                            periodicalList: apiResult.data,
                            totalPeriodicalListItems: apiResult?.totalRecords,
                            sortedIdArray: apiResult.sortedIdArray,
                            periodicalListLoading: false
                        });
                    } else {
                        this.setState({
                            periodicalList: {},
                            totalPeriodicalListItems: 0,
                            periodicalListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        periodicalList: {},
                        totalPeriodicalListItems: 0,
                        periodicalListLoading: false
                    });
                }
            }
        }
    }

    //API CALL METHOD TO LIST OF CATEGORIES
    getPeriodicalCategoryList = async () => {

        this.setState({
            periodicalCategoryListLoading: true
        });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    periodicalCategoryList: apiResult,
                    periodicalCategoryListLoading: false
                });

            }
        }
    }

    // filter title on change
    handleTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByTitle: event.target.value });
    };
    handlePeriodicalTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.getPeriodicalList();
        }
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({
            pageIndex: 1, limit: event.target.value, searchByTitle: this.state.searchByTitle, searchByPeriodicalCategory: this.state.searchByPeriodicalCategory, searchByPeriodicity: this.state.searchByPeriodicity, searchByStatus: this.state.searchByStatus
        }, () => {
            this.getPeriodicalList();
        });
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByTitle: this.state.searchByTitle, searchByPeriodicalCategory: this.state.searchByPeriodicalCategory, searchByPeriodicity: this.state.searchByPeriodicity, searchByStatus: this.state.searchByStatus }, () => {
            this.getPeriodicalList();
        });
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByTitle: '', searchByPeriodicalCategory: '', searchByPeriodicity: '', searchByStatus: 'active', limit: "10", pageIndex: 1
        }, () => {
            this.getPeriodicalList();
        }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterPeriodicalTitle = this.state.searchByTitle
        let filterPeriodicalCategory = Object.values(this.state.periodicalCategoryList)?.filter((data) => data?.uniqueid == this.state.searchByPeriodicalCategory)
        let filterPeriodicity = this.state.searchByPeriodicity
        let filterStatus = this.state.searchByStatus

        if (filterPeriodicalTitle) {
            FilterArray.push(`Periodical Title - ${filterPeriodicalTitle}`)
        }
        if (filterPeriodicalCategory.length > 0) {
            FilterArray.push(`Periodical Category -  ${filterPeriodicalCategory[0].category_name}`)
        }
        if (filterPeriodicity) {
            FilterArray.push(`Periodicity - ${filterPeriodicity}`)
        }
        if (filterStatus) {
            FilterArray.push(`Status - ${filterStatus}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllPeriodicalReportList" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                Periodical Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>ISSN Number</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Category</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>No. of Copies</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Periodicity</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Department</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>No. of Subscription</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Average Price Per Copy</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Publisher</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="8">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((periodical, index) => {
                                    let periodicity = periodical.periodicity.charAt(0).toUpperCase() + periodical.periodicity.slice(1);

                                    switch (periodical.periodicity) {
                                        case 'bimonthly':
                                            periodicity = 'Bi Monthly';
                                            break;
                                        case 'half yearly':
                                            periodicity = 'Half yearly';
                                            break;
                                        case 'tri annually':
                                            periodicity = 'Tri Annually';
                                            break;
                                        default:
                                            break;
                                    }
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{periodical?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{periodical?.ISSN || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{periodical?.periodicalCategoryName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{periodical?.totalNumberOfIssues || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{periodicity}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{periodical?.Department?.join(', ') || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{periodical?.subscriptions.length != 0 ? periodical.subscriptions.length : '-'}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>₹ {periodical?.avgPricePerCopy.toFixed(2) || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{periodical?.publisher || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="8">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalPeriodicalListItems } = this.state;
        const totalPages = Math.ceil(totalPeriodicalListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let filterData = {
                "title": this.state.searchByTitle,
                "periodicity": this.state.searchByPeriodicity,
                "periodical_category_id": this.state.searchByPeriodicalCategory
            }

            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'filterData': filterData,
                'status': this.state.searchByStatus
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'getPeriodicalList',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                    }, () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterPeriodicalTitle = this.state.searchByTitle
        let filterPeriodicalCategory = Object.values(this.state.periodicalCategoryList)?.filter((data) => data?.uniqueid == this.state.searchByPeriodicalCategory)
        let filterPeriodicity = this.state.searchByPeriodicity
        let filterStatus = this.state.searchByStatus

        if (filterPeriodicalTitle) {
            FilterArray.push(`Periodical Title - ${filterPeriodicalTitle}`)
        }
        if (filterPeriodicalCategory.length > 0) {
            FilterArray.push(`Periodical Category -  ${filterPeriodicalCategory[0].category_name}`)
        }
        if (filterPeriodicity) {
            FilterArray.push(`Periodicity - ${filterPeriodicity}`)
        }
        if (filterStatus) {
            FilterArray.push(`Status - ${filterStatus}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Search by periodical title */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Title</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByTitleFilter"
                                                                    placeholder="Search by Title"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByTitle} // Bind value to state
                                                                    onChange={this.handleTitleChange} // Handle input changes
                                                                    onKeyPress={this.handlePeriodicalTitleKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by Periodical Category */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Periodical Category</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <select
                                                                    className="form-control formControlContentTask"
                                                                    style={{
                                                                        // width: 'auto',
                                                                        width: '165px',
                                                                        height: '42px',
                                                                        fontSize: "12px",
                                                                        fontWeight: 400,
                                                                        lineHeight: '20px',
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        color: '#808080',
                                                                        borderRadius: '7px'
                                                                    }}
                                                                    id="searchByInstituteFilter"
                                                                    onChange={(e) => {
                                                                        this.setState({
                                                                            searchByPeriodicalCategory: e.target.value
                                                                        }, () => {
                                                                            this.getPeriodicalList();  // Call the API to fetch data
                                                                        })
                                                                    }} // Attach handler here
                                                                    value={this.state.searchByPeriodicalCategory} // Bind dropdown value to state
                                                                >
                                                                    <option value="">Select Category</option>
                                                                    {
                                                                        Object.keys(this.state.periodicalCategoryList).map(category => {
                                                                            let categoryName = this.state.periodicalCategoryList[category]

                                                                            return (
                                                                                <option style={{ fontSize: '13px' }} value={category}>{categoryName.category_name}</option>
                                                                            );
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {/* Based On Search By Periodicity*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Periodicity</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <select
                                                                    className="form-control formControlContentTask"
                                                                    style={{
                                                                        // width: 'auto',
                                                                        width: '165px',
                                                                        height: '42px',
                                                                        fontSize: "12px",
                                                                        fontWeight: 400,
                                                                        lineHeight: '20px',
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        color: '#808080',
                                                                        borderRadius: '7px'
                                                                    }}
                                                                    id="searchByInstituteFilter"
                                                                    onChange={(e) => {
                                                                        this.setState({
                                                                            searchByPeriodicity: e.target.value
                                                                        }, () => {
                                                                            this.getPeriodicalList();  // Call the API to fetch data
                                                                        })
                                                                    }} // Attach handler here
                                                                    value={this.state.searchByPeriodicity} // Bind dropdown value to state
                                                                >
                                                                    <option value="">Select Periodicity</option>
                                                                    <option value="daily">Daily</option>
                                                                    <option value="weekly">Weekly</option>
                                                                    <option value="fortnightly">Fortnightly</option>
                                                                    <option value="monthly">Monthly</option>
                                                                    <option value="bimonthly">Bi Monthly</option>
                                                                    <option value="quarterly">Quarterly</option>
                                                                    <option value="half yearly">Half yearly</option>
                                                                    <option value="yearly">Yearly</option>
                                                                    <option value="triennial">Triennial</option>
                                                                    <option value="tri annually">Tri Annually</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {/* Based On Search By Status*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Status</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <select
                                                                    className="form-control formControlContentTask"
                                                                    style={{
                                                                        // width: 'auto',
                                                                        width: '165px',
                                                                        height: '42px',
                                                                        fontSize: "12px",
                                                                        fontWeight: 400,
                                                                        lineHeight: '20px',
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        color: '#808080',
                                                                        borderRadius: '7px'
                                                                    }}
                                                                    onChange={(e) => {
                                                                        this.setState({
                                                                            searchByStatus: e.target.value
                                                                        }, () => {
                                                                            this.getPeriodicalList();  // Call the API to fetch data
                                                                        })
                                                                    }} // Attach handler here
                                                                    value={this.state.searchByStatus} // Bind dropdown value to state
                                                                >
                                                                    <option value="active">Active</option>
                                                                    <option value="inactive">Inactive</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get Periodical Report filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        {/* <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div> */}

                                        {Object.keys(this.state.periodicalList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="periodicalReportList"
                                                                    filename="PeriodicalReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllPeriodicalReportList"   // export all functionality
                                                                    filename="ExportAllPeriodicalReportList"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByTitle !== '' || this.state.searchByPeriodicalCategory !== '' || this.state.searchByPeriodicity !== '' || this.state.searchByStatus !== 'active') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Periodical Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="periodicalReportList">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        Periodical Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>ISSN Number</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Category</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>No. of Copies</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Periodicity</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Department</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>No. of Subscription</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Average Price Per Copy</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Publisher</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.periodicalListLoading ?
                                                    <tr>
                                                        <td colSpan="15">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    this.state.sortedIdArray.length > 0 > 0 ?
                                                        this.state.sortedIdArray.map((periodicalId, index) => {
                                                            let periodical = this.state.periodicalList[periodicalId];
                                                            let periodicity = periodical.periodicity.charAt(0).toUpperCase() + periodical.periodicity.slice(1);

                                                            switch (periodical.periodicity) {
                                                                case 'bimonthly':
                                                                    periodicity = 'Bi Monthly';
                                                                    break;
                                                                case 'half yearly':
                                                                    periodicity = 'Half yearly';
                                                                    break;
                                                                case 'tri annually':
                                                                    periodicity = 'Tri Annually';
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{periodical?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{periodical?.ISSN || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{periodical?.periodicalCategoryName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{periodical?.totalNumberOfIssues || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{periodicity}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{periodical?.Department?.join(', ') || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{periodical?.subscriptions.length != 0 ? periodical.subscriptions.length : '-'}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>₹ {periodical?.avgPricePerCopy.toFixed(2) || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{periodical?.publisher || ""}</td>}
                                                                </tr>
                                                            )
                                                        }) :
                                                        <tr>
                                                            <td colSpan="15">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.periodicalList).length > 0 || Object.keys(this.state.periodicalList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalPeriodicalListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalPeriodicalListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                </div>
            </div >

        );
    }
}


export default PeriodicalReport;